// extracted by mini-css-extract-plugin
export default {"container":"yl-z","blurb":"zl-z","links":"Al-z"};